// const url_req = "https://nip.app.support.pl/test.php"
const url_req = "./php/request.php"


function generateFormData(data = {}) {
	let formData = new FormData();
	for (let [key, value] of Object.entries(data)) {
		formData.append(key, value)
	}
	return formData;
}
export default {
	actions: {
		async fetchCheckLicenseNip(context) {
			const response = await fetch(url_req, {
				method: 'POST',
				body: generateFormData({ method: 'Check license', DOMAIN: 'https://' + context.rootState.auth.domain })
			})
			const result = await response.json()

			if (result.app_settings) {
				context.dispatch('BXsetSettingsAppFromTheDB', JSON.parse(result.app_settings))
			}
		},
		async BXsearchCompanyByNIP(context, NIP) {
			if (context.state.companyFieldForNIP) {
				BX24.callMethod(
					"crm.company.list",
					{
						filter: { [context.state.companyFieldForNIP]: NIP }
					},
					(result) => {
						if (result.error()) {
							console.error(result.error());
						} else {
							var res = result.data()[0]
							context.commit('setData', { name: 'searchCompanyNip', data: res })
						}
					}
				);
			}
		},
		CreateFormData(context, dataOnNIP) {
			var form = {}
			if (context.state.saveCompanyTypeNip.Fields) {
				for (let [key, value] of Object.entries(context.state.settingsNip)) {
					form[value.id] = dataOnNIP[key]
				}
			} else {
				for (let key of Object.keys(context.state.settingsNip)) {
					form[key] = dataOnNIP[key]
				}
			}
			form['TITLE'] = dataOnNIP['TITLE']
			context.commit('updateFormData', form)
		},
		NextStep(context) {
			context.commit('updateStep', true)
		},
		ResetStep(context) {
			context.commit('resetStep')
		},
		PrevStep(context) {
			context.commit('updateStep', false)
		},
		async fetchSearchCompanyByNIP(context, nip) {
			const response = await fetch(url_req, {
				method: 'POST',
				body: generateFormData({ method: 'Search company by NIP', NIP: nip })
			})
			const result = await response.json()
			console.log('%c fetchSearchCompanyByNIP', 'color:#1890ff;font-weight:bold;', result)
			context.commit('setInformationOnNip', result)
		},
		CreateCompany(context) {
			// context.dispatch("changeSpinning")
			BX24.callMethod(
				"crm.company.add",
				{
					fields: context.state.saveCompanyTypeNip.Fields ? context.state.formData : {
						//NOTE context.state.formData.SHORT_TITLE
						TITLE: context.state.formData.TITLE,
						[context.state.companyFieldForNIP]: context.state.formData.NIP
					},
					params: { REGISTER_SONET_EVENT: "Y" }
				},
				result => {
					if (result.error())
						console.error(result.error());
					else {
						var companyID = result.data();
						console.info("1) Создана компания с ID " + companyID);
						if (context.state.saveCompanyTypeNip.Fields) {
							context.commit('resultFormData', { id: companyID, type: 'created', saveTo: 'fields' })
						}
						if (context.state.saveCompanyTypeNip.Requisites) {
							context.dispatch('AddCompanyRequisite', companyID);
						}
						context.dispatch('NextStep');
					}
				})
		},
		UpdateCompany(context) {
			var companyID = context.state.searchCompanyNip['ID'];
			// context.dispatch("changeSpinning")
			BX24.callMethod(
				"crm.company.update",
				{
					id: companyID,
					fields: context.state.saveCompanyTypeNip.Fields ? context.state.formData : {
						//NOTE context.state.formData.SHORT_TITLE
						TITLE: context.state.formData.TITLE,
						[context.state.companyFieldForNIP]: context.state.formData.NIP
					},
					params: { REGISTER_SONET_EVENT: "Y" }
				},
				result => {
					if (result.error()) {
						console.error(result.error());
					} else {
						console.info("Обновлены поля компания с ID " + companyID, result.data())
						if (context.state.saveCompanyTypeNip.Fields) {
							context.commit('resultFormData', { id: companyID, type: 'updated', saveTo: 'fields' })
						}
						if (context.state.saveCompanyTypeNip.Requisites) {
							context.dispatch('UpdateCompanyRequisite', companyID)
						}
						context.dispatch('NextStep');
					}
				}
			);
		},
		AddCompanyRequisite(context, companyID) {
			BX24.callMethod(
				"crm.requisite.preset.list", {},
				(result) => {
					if (result.error())
						console.error(result.error());
					else {
						var presetID = result.data()[0].ID;
						var entityTypeID = 4;
						BX24.callMethod(
							"crm.requisite.add",
							{
								fields:
								{
									"ENTITY_TYPE_ID": entityTypeID,
									"ENTITY_ID": companyID,
									"PRESET_ID": presetID,
									"NAME": context.state.formData.TITLE,
								}
							},
							(result) => {
								if (result.error())
									console.error(result.error());
								else {
									var requisiteID = result.data()
									var fieldsAdd = {
										"COUNTRY": '',
										"CITY": '',
										"POSTAL_CODE": '',
										"ADDRESS_1": '',
										"ADDRESS_2": '',
									};
									if (context.state.saveCompanyTypeNip.Fields) {
										for (let i in fieldsAdd) {
											if (context.state.formData[context.state.settingsNip[i].id])
												fieldsAdd[i] = context.state.formData[context.state.settingsNip[i].id];
										}
									} else {
										for (let i in fieldsAdd) {
											if (context.state.formData[i])
												fieldsAdd[i] = context.state.formData[i];
										}
									}
									BX24.callMethod(
										"crm.address.add",
										{
											fields:
											{
												"TYPE_ID": 4,
												"ENTITY_TYPE_ID": 8,
												"ENTITY_ID": requisiteID,
												...fieldsAdd
											}
										},
										(result) => {
											if (result.error())
												console.error(result.error());
											else {
												console.dir('4) ADD Requisite !!!', result.data());
												context.commit('resultFormData', { id: companyID, type: 'created', saveTo: 'requisite' })
											}
										}
									);
								}
							}
						);
					}
				}
			);
		},
		UpdateCompanyRequisite(context, companyID) {
			BX24.callMethod(
				"crm.requisite.list",
				{
					filter: { "ENTITY_ID": companyID },
				},
				function (result) {
					if (result.error())
						console.error(result.error());
					else {
						var lastRequisite = result.data().pop();
						if (lastRequisite) {
							var fieldsAdd = {
								"COUNTRY": '',
								"CITY": '',
								"POSTAL_CODE": '',
								"ADDRESS_1": '',
								"ADDRESS_2": '',
							};
							if (context.state.saveCompanyTypeNip.Fields) {
								for (let i in fieldsAdd) {
									if (context.state.formData[context.state.settingsNip[i].id])
										fieldsAdd[i] = context.state.formData[context.state.settingsNip[i].id];
								}
							} else {
								for (let i in fieldsAdd) {
									if (context.state.formData[i])
										fieldsAdd[i] = context.state.formData[i];
								}
							}
							BX24.callMethod(
								"crm.address.update",
								{
									fields:
									{
										"TYPE_ID": 4,
										"ENTITY_TYPE_ID": 8,
										"ENTITY_ID": lastRequisite.ID,
										...fieldsAdd
									}
								},
								function (result) {
									if (result.error()) {
										console.error(result.error());
									} else {
										console.info("Обновлены реквизиты компания с ID " + companyID, result.data())
										context.commit('resultFormData', { id: companyID, type: 'created', saveTo: 'requisite' })
									}
								}
							);
						}
					}
				}
			);
		},
		async BXsetSettingsApp(context, companyFields) {
			console.log('BXsetSettingsApp', companyFields);
			var kk = { NIP: { id: '', name: '' }, COUNTRY: { id: '', name: '' }, CITY: { id: '', name: '' }, ADDRESS_1: { id: '', name: '' }, ADDRESS_2: { id: '', name: '' }, POSTAL_CODE: { id: '', name: '' } }
			for (let [key, value] of Object.entries(companyFields)) {
				kk[key] = value
			}
			await BX24.appOption.set('companyFields', kk, () => console.log('BXsetSettingsApp', kk));
			context.commit('setData', { name: 'settingsNip', data: kk })
			await context.dispatch('fetchSaveSettingsInDB')
		},
		async BXsetSettingsAppFromTheDB(context, app_settings) {
			let { settings, saveCompanyType, companyFieldForNIP } = app_settings;
			if (saveCompanyType) {
				context.commit('setData', { name: 'saveCompanyTypeNip', data: saveCompanyType })
			}
			if (settings) {
				context.commit('setData', { name: 'settingsNip', data: settings })
			}
			if (companyFieldForNIP) {
				context.commit('setData', { name: 'companyFieldForNIP', data: companyFieldForNIP })
			}
		},
		async fetchSaveSettingsInDB(context) {
			let settings = {
				companyFieldForNIP: context.state.companyFieldForNIP,
				saveCompanyType: context.state.saveCompanyTypeNip,
				settings: context.state.settingsNip
			}
			const response = await fetch(url_req, {
				method: 'POST',
				body: generateFormData({ method: 'Save settings in DB', DOMAIN: 'https://' + context.rootState.auth.domain, settings: JSON.stringify(settings) })
			})
			const result = await response.json()
			console.log('fetchSaveSettings', result)
		},
		async BXsetCompanyFieldForNIPApp(context, companyFieldForNIP) {
			await BX24.appOption.set('companyFieldForNIP', companyFieldForNIP, () => console.log('Set CompanyFieldForNIP', companyFieldForNIP));
			context.commit('setData', { name: 'companyFieldForNIP', data: companyFieldForNIP })
			await context.dispatch('fetchSaveSettingsInDB')
		},
		async BXsetCompanySaveTypeApp(context, saveCompanyType) {
			await BX24.appOption.set('saveCompanyType', saveCompanyType, () => console.log('BXsetCompanySaveTypeApp', saveCompanyType));
			context.commit('setData', { name: 'saveCompanyTypeNip', data: saveCompanyType })
			await context.dispatch('fetchSaveSettingsInDB')
		},
	},
	mutations: {
		updateStep(state, flagNext) {
			if (flagNext) {
				if (state.step == 2) {
					state.step = 0
				} else {
					state.step++
				}
			} else {
				if (state.step == 0) {
					state.step = 2
				} else {
					state.step--
				}
			}
		},
		resetStep(state) {
			state.step = 0
		},
		setData(state, params) {
			state[params.name] = params.data;
		},
		updateFormData(state, data) {
			state.formData = data
		},
		setInformationOnNip(state, result) {
			if (!result.error) {
				let nip_result = result.nip_result
				state.informationOnNip = {
					NIP: result.nip,
					VAT_STATUS: result.statusVAT,
					TITLE: nip_result.TITLE,
					COUNTRY: nip_result.COUNTRY[0],
					CITY: nip_result.CITY[0],
					POSTAL_CODE: nip_result.POSTAL_CODE[0],
					ADDRESS_1: nip_result.ADDRESS_1,
					ADDRESS_2: nip_result.ADDRESS_2[0],
				}
			} else {
				state.informationOnNip = result;
			}
		},
		resultFormData(state, result) {
			state.formData['result'] = result
		}
	},
	state: {
		step: 0,
		licenseNip: false,
		settingsNip: {},
		formData: {},
		saveCompanyTypeNip: { Requisites: true, Fields: false },
		companyFieldForNIP: {},
		searchCompanyNip: false,
		informationOnNip: {},
	},
	getters: {
		HomeStep(state) {
			return state.step
		},
		licenseNip(state) {
			return state.licenseNip
		},
		settingsNip(state) {
			return state.settingsNip
		},
		saveCompanyTypeNip(state) {
			return state.saveCompanyTypeNip
		},
		searchCompanyNip(state) {
			return state.searchCompanyNip
		},
		companyFieldForNIP(state) {
			return state.companyFieldForNIP
		},
		FormData(state) {
			return state.formData
		},
		InfoOnNIP(state) {
			return state.informationOnNip
		}
	}
}